/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export enum ProcedurePriceType {
  MAIN_SURGEON = 'Main Surgeon Charges',

  ANAESTHESIA = 'Anesthesia Charges',

  OTHER_SURGEON = 'Other Surgeon Charges',

  GYNECOLOGIST_CHARGES = 'Gynecologist Charges',

  BloodTransfusioncharges = 'Blood Transfusion Charges',

  DressingCharges = 'Dressing Charges',

  Equipment = 'Equipment Charges',

  LabourRoomCharges = 'Labour Room Charges',

  PEDIATRICIAN_CHARGES = 'Pediatrician Charges',

  MedicalServices = 'Medical Services',

  OxygenCharges = 'Oxygen Charges',

  OtherCharges = 'Other Charges',

  OperationTheatreCharges = 'Operation Theatre Charges',

  Physiotherapy = 'Physiotherapy',

  Scanning = 'Scanning',

  TreatmentCharges = 'Treatment Charges',

  X_Ray = 'X-Ray',

  WardProcedures = 'Surgical Procedures',

  CardiacMonitoring = 'Cardiac Monitoring',

  Nebulisation = 'Nebulisation',

  Echo = 'Echo',

  SyringePump = 'Syringe Pump',

  OperationTheatreNursingCharges = 'Operation Theatre Nursing Charges',

  OperationTheatreMachineryCharges = 'Operation Theatre Machinery Charges',

  TheaterConsumbale = 'Theater Consumables &amp; Drugs',

  HospitalSupportService = 'Hospital Support Service',

  ExtraMedicine = 'Extra Medicine',

  DialysisTreatment = 'Dialysis Treatment Charges',

  Investigations = 'Operation Theatre Investigations',
}
